'use strict';

var FlightLevelFilterFactory = function FlightLevelFilterFactory($filter, DataFilter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function FlightLevelFilter() {
    DataFilter.call(this, ['cabin', 'cabin-da', 'class'], 'flightLevel', 1);
  }
  FlightLevelFilter.prototype = Object.create(DataFilter.prototype);
  function getFilterKeyFor(element) {
    return [rmMomentFormat(element.legDepartureDateMoment, 'TIME_ISO'), element.flightNumber, element.opsSuffix].join(' ');
  }
  FlightLevelFilter.prototype.filter = function (data, range) {
    if (Array.isArray(range) && range.length >= 1) {
      var filteredData = [];
      for (var i = 0, len = data.length; i < len; i++) {
        var element = data[i];
        var filterKey = element.numberAndDate || getFilterKeyFor(element);
        for (var j = 0; j < range.length; j++) {
          var rangeElement = range[j];
          if (rangeElement === filterKey) {
            filteredData.push(element);
          }
        }
      }
      return filteredData;
    } else {
      return data;
    }
  };
  return FlightLevelFilter;
};
FlightLevelFilterFactory.$inject = ['$filter', 'DataFilterFactory'];
module.exports = FlightLevelFilterFactory;